interface Props {
	prevX: number;
	prevY: number;
	currX: number;
	currY: number;
}

export default function getSmoothCurvePath({
	prevX,
	prevY,
	currX,
	currY,
}: Props) {
	const cp1x = prevX + (currX - prevX) / 3;
	const cp2x = currX - (currX - prevX) / 3;

	return ` C ${cp1x},${prevY} ${cp2x},${currY} ${currX},${currY}`;
}
